import { RadioButtonValgModel } from '../../Shared/Scripts/Components/RadioButtonValg';
import VeilederHounDto from '../Models/VeilederHounDto';

const heltAr = 'b1-heltAr';
const host = 'b2-host';
const vaar = 'b3-var';
const hostx = 'b4-host';
const vaarx = 'b5-var';

const map = {
    'b1-heltAr': 10,
    'b2-host': 5,
    'b3-var': 5,
    'b4-host': 5,
    'b5-var': 6,
};

const bValg: RadioButtonValgModel<VeilederHounDto>[] = [
    { id: 'b1', value: heltAr, tekst: 'valgHeleAret' },
    { id: 'b2', value: host, tekst: 'valgHostsemester' },
    { id: 'b3', value: vaar, tekst: 'valgVarsemester' },
];

const bxValg: RadioButtonValgModel<VeilederHounDto>[] = [
    { id: 'b4', value: hostx, tekst: 'valgHostHalvtSemester' },
    { id: 'b5', value: vaarx, tekst: 'valgVarHalvtSemester' },
];

export default {
    b1_heltAr: heltAr,
    b2_host: host,
    b3_var: vaar,
    b4_host: hostx,
    b5_var: vaarx,
    bValg,
    bxValg,

    antallMnd: (semesterType: string): number => {
        return map[semesterType];
    },
};
